<template>
  <div class="share-socials-modal flex flex-col w-full h-full ">
    <div class="site-sharing">
      <span class="copy" @click="copy">
        <i class="pi pi-link" />
        <span style="margin-right: 0.25rem">העתק קישור</span>
      </span>
      <span class="go-to-site" @click="goToSite">
        <i class="pi pi-external-link" />
      </span>
    </div>
    <div class="social-row">
      <div class="social-wrapper">
        <ShareNetwork
          network="whatsapp"
          :url="siteUrl"
          title="היי, אני רוצה לשתף אותך באתר החדש שלי 😃"
          description="מפה תוכלו לזמן תורים, לקבל תזכורות, ולראות את כל השירותים שאנחנו מציעים!"
        >
          <div class="social-box">
            <i class="pi pi-whatsapp whatsapp" />
            <span>שיתוף בהודעת WhatsApp</span>
          </div>
        </ShareNetwork>
      </div>
      <div class="social-wrapper">
        <ShareNetwork
          network="facebook"
          title="היי, אני רוצה לשתף אותך באתר החדש שלי 😃"
          :url="siteUrl"
          hashtags="זימון_תורים"
        >
          <div class="social-box">
            <i class="pi pi-facebook facebook" />
            <span>פרסום בפייסבוק</span>
          </div>
        </ShareNetwork>
      </div>
      <div class="social-wrapper">
        <ShareNetwork
          network="sms"
          :url="siteUrl"
          title="היי, אני רוצה לשתף אותך באתר החדש שלי 😃"
          description="מפה תוכלו לזמן תורים, לקבל תזכורות, ולראות את כל השירותים שאנחנו מציעים!"
        >
          <div class="social-box">
            <i class="pi pi-comments sms" />
            <span>שיתוף בהודעת SMS</span>
          </div>
        </ShareNetwork>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useAdminStore } from '@app/stores';
import { openLinkNewTab } from '@torim-app/utils';
import { Capacitor } from '@capacitor/core';
import { Clipboard } from '@capacitor/clipboard';
import { trackEvent } from '@app/composables/posthog';

const toast = useToast();
const store = useAdminStore();

const siteUrl = ref(
  `${import.meta.env.VITE_BUSINESS_WEBSITE_DOMAIN}/business/${
    store.getBusinessSiteData.bid
  }`
);

const copy = async () => {
  trackEvent('share_link_copied');
  if (Capacitor.isNativePlatform()) {
    await Clipboard.write({
      string: siteUrl.value
    });
  } else {
    await navigator.clipboard.writeText(siteUrl.value);
  }
  toast.success('הקישור הועתק בהצלחה 😃');
};

const goToSite = () => {
  openLinkNewTab(siteUrl.value);
};
</script>

<style lang="scss" scoped>
.share-socials-modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  .site-sharing {
    display: flex;
    padding: 0 2rem 1rem 2rem;
    flex-direction: row;
    gap: 0.5rem;
    width: 100%;

    .go-to-site, .copy {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #efefef;
      padding: 1rem;
      border-radius: 0.5rem;
      font-weight: 500;
    }

    .go-to-site {
      width: 4rem;
    }

    .copy {
      flex-grow: 1;
    }
  }

  .social-row {
    display: flex;
    gap: 1rem;
    padding: 0.5rem;

    .social-wrapper {
      width: 33%;
    }

    .social-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      i {
        padding: 1rem;
        color: white;
        border-radius: 0.5rem;

        &.whatsapp {
          background: #25d366;
        }

        &.facebook {
          background: #4267b2;
        }

        &.sms {
          background: #343434;
        }
      }

      span {
        margin-top: 0.5rem;
        text-align: center;
        font-weight: 500;
        font-size: 0.8rem;
      }
    }
  }
}
</style>
